export const slugify = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")          // G&A → gand
    .replace(/[^a-z0-9\s-]/g, "")  // remove everything else
    .replace(/\s+/g, "-")          // replace spaces
    .replace(/-+/g, "-")           // collapse multiple dashes
    .replace(/^-+|-+$/g, "");      // trim dashes from start/end
